import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Modal, Button, Row, Col, Alert } from 'react-bootstrap';
import { MiniCalendar } from '@mantine/dates';
import { getTimeRange, TimeGrid } from '@mantine/dates';

import {
  GoogleMap,
  useLoadScript,
  MarkerF,
} from '@react-google-maps/api';

const libraries = ['places'];

const options = {
  disableDefaultUI: true,
  zoomControl: true,
};
const nolink = '#store-container';

function Store({ store }) {
  const { id } = useParams();

  const [showModalWindow, setShowModalWindow] = useState(false);
  const [appointmentDate, setAppointmentDate] = useState(
    store.appointment_date
  );
  const [appointmentTime, setAppointmentTime] = useState(
    store.appointment_time
  );
  const [appointmentNote, setAppointmentNote] = useState(
    store.appointment_note
  );
  const [showAlert, setShowAlert] = useState(false);

  const handleOpenModalWindow = () => {
    setShowModalWindow(true);
  };
  const handleCloseModalWindow = () => {
    setShowAlert(false);
    setShowModalWindow(false);
  };

  const selectAppointmentDate = (v) => {
    setAppointmentDate(v);
  };

  const selectAppointmentTime = (v) => {
    setAppointmentTime(v);
  };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: 'AIzaSyASb6hqC_vdC4GBlcYeScVExGqRQbz-8ls',
    libraries,
  });

  const mapContainerStyle = {
    width: '100%',
    height: '60vh',
  };

  const [map, setMap] = useState(null);
  const [center, setCenter] = useState({
    lat: 32.7088,
    lng: -97.1144, // Initial center (Arlington)
    zoom: 8,
  });

  const handleAppointmentPostRequest = async () => {
    try {
      const response = await fetch(
        'https://leadsherpapost.com/qc/api/v1/postapp/' + id,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Request-Method': 'POST, OPTIONS',
          },
          body: JSON.stringify({
            appointment_date: appointmentDate,
            appointment_time: appointmentTime,
            appointment_note: appointmentNote,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Success:', data);
      setShowAlert(true);
      // Handle successful response, e.g., navigate to another page
    } catch (error) {
      console.error('Error:', error);
      // Handle errors, e.g., display an error message to the user
    }
  };

  useEffect(() => {
    if (store) {
      setCenter({
        lat: store.latitude,
        lng: store.longitude,
        zoom: 15,
      });
    }
  }, [store]);

  const handleLoad = (map) => {
    setMap(map);
  };

  if (loadError) {
    return <div>Error loading Google Maps API</div>;
  }

  return (
    <div className="store-container" id="store-container">
      <div className="p-2 p-md-4 p-lg-5 p-xl-5">
        <div className="row mb-2">
          <div className="col-12 col-lg-4 col-md-4 col-sm-4">
            <h3>Your closest location:</h3>
            {store ? (
              <div className="store-info">
                <br /> <h5>Address:</h5>
                <div>{store.address}</div>
                <span>{store.city}</span>, <span>{store.state}</span>{' '}
                <span>{store.zip}</span>
                <br />
                <div>* {store.directions}</div>
                {store.website ? (
                  <a
                    href={store.website}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div>About Store</div>
                  </a>
                ) : (
                  <span></span>
                )}
                <br />
                <div>
                  <h5>Phone Number:</h5>
                </div>
                <div>
                  <a href={'tel: ' + store.phone}>{store.phone}</a>
                </div>
                <div className="mt-2">
                  <a
                    href={
                      'mailto: ' +
                      store.email +
                      '?subject=Loan with LendNation'
                    }
                  >
                    <span className="phone-button2">SEND E-MAIL</span>
                  </a>
                </div>
                <div className="mb-4">
                  <br />
                  <br />
                  <h5>Hours:</h5>
                  Monday: <span>{store.hours_mo}</span>
                  <br />
                  Tuesday: <span>{store.hours_tu}</span>
                  <br />
                  Wednesday: <span>{store.hours_we}</span>
                  <br />
                  Thursday: <span>{store.hours_th}</span>
                  <br />
                  Friday: <span>{store.hours_fr}</span>
                  <br />
                  Saturday: <span>{store.hours_sa}</span>
                  <br />
                  Sunday: <span>{store.hours_su}</span>
                </div>
              </div>
            ) : (
              <div></div>
            )}
          </div>
          <div className="col-12 col-lg-8 col-md-8 col-sm-8 text-center">
            <a href={nolink} onClick={handleOpenModalWindow}>
              <span className="phone-button">
                REQUEST APPOINTMENT
              </span>
            </a>
            <div className="pt-3">
              <div className="text-end">
                {isLoaded && center ? (
                  <GoogleMap
                    mapContainerStyle={mapContainerStyle}
                    zoom={center.zoom}
                    center={center}
                    onLoad={handleLoad}
                    options={options}
                  >
                    {map && store && (
                      <MarkerF
                        position={{
                          lat: store.latitude,
                          lng: store.longitude,
                        }}
                        icon={{
                          url: require('../results_map_circle.png'),
                          fillColor: '#EB00FF',
                          scale: 10,
                        }}
                        label={{ text: '1', color: '#fff' }}
                      />
                    )}
                  </GoogleMap>
                ) : (
                  <div>Loading Map...</div>
                )}
              </div>
            </div>
            <Modal
              show={showModalWindow}
              onHide={handleCloseModalWindow}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Appointment details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg="7">
                    <div>
                      <strong>Location: </strong> {store.address}{' '}
                      {store.city}, {store.state} {store.zip}
                    </div>
                    <div>
                      <strong>* </strong> {store.directions}
                    </div>
                    <br />
                    <div>
                      <strong>Phone: </strong> {store.phone}
                    </div>
                  </Col>
                  <Col lg="5">
                    <strong>Hours:</strong>
                    <br />
                    <div>Monday: {store.hours_mo}</div>
                    <div>Tuesday: {store.hours_tu}</div>
                    <div>Wednesday: {store.hours_we}</div>
                    <div>Thursday: {store.hours_th}</div>
                    <div>Friday: {store.hours_fr}</div>
                    <div>Saturday: {store.hours_sa}</div>
                    <div>Sunday: {store.hours_su}</div>
                  </Col>
                </Row>
                <hr />
                <Row className="row mb-2">
                  <Col lg="6">
                    <strong>Schedule Time:</strong>
                    <br />
                    <MiniCalendar
                      value={appointmentDate}
                      onChange={selectAppointmentDate}
                      numberOfDays={7}
                      size="md"
                    />
                    <br />
                    <TimeGrid
                      data={getTimeRange({
                        startTime: '9:00',
                        endTime: '18:00',
                        interval: '00:30',
                      })}
                      simpleGridProps={{
                        type: 'container',
                        cols: { base: 1, '180px': 2, '320px': 3 },
                        spacing: 'xs',
                      }}
                      withSeconds={false}
                      value={appointmentTime}
                      format="12h"
                      onChange={selectAppointmentTime}
                    />
                  </Col>
                  <Col lg="6">
                    <div>
                      <strong>Notes:</strong>
                      <br />
                      <textarea
                        className="notes-field"
                        value={appointmentNote}
                        onChange={(e) =>
                          setAppointmentNote(e.target.value)
                        }
                      ></textarea>
                    </div>
                  </Col>
                </Row>
                {showAlert && (
                  <Alert
                    variant="success"
                    onClose={handleCloseModalWindow}
                    dismissible
                  >
                    <Alert.Heading>Success!</Alert.Heading>
                    <p>
                      You're all set! A confirmation email with the
                      date, time, and location of your appointment is
                      on its way.
                    </p>
                  </Alert>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={handleCloseModalWindow}
                >
                  Close
                </Button>
                <Button
                  variant="primary"
                  onClick={handleAppointmentPostRequest}
                >
                  Save Changes
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>

        <div className="row mb-2"></div>
      </div>
    </div>
  );
}

export default Store;
